import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function PopularWorks() {
  const workArticles = articles.filter((a) => a.category === 'works').slice(0, 4);

  const works = [
    {
      slug: 'anzai-rara-classic-works-top10',
      title: '安斋拉拉经典作品TOP10推荐',
      imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20artistic%20minimalist%20portrait%20style%20with%20warm%20coral%20and%20cream%20soft%20tones%2C%20dreamy%20atmospheric%20lighting%2C%20abstract%20organic%20composition%2C%20clean%20simple%20background%2C%20editorial%20aesthetic%2C%20no%20text%2C%20no%20face%2C%20no%20people&width=600&height=800&seq=work-portrait-01&orientation=portrait',
    },
    {
      slug: 'anzai-rara-latest-work-review',
      title: '安斋拉拉最新力作深度评测',
      imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20artistic%20minimalist%20portrait%20style%20with%20warm%20coral%20and%20cream%20soft%20tones%2C%20dreamy%20atmospheric%20lighting%2C%20abstract%20organic%20composition%2C%20clean%20simple%20background%2C%20editorial%20aesthetic%2C%20no%20text%2C%20no%20face%2C%20no%20people&width=600&height=800&seq=work-portrait-02&orientation=portrait',
    },
    {
      slug: 'anzai-rara-2025-year-review',
      title: '安斋拉拉2025年度回顾',
      imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20artistic%20minimalist%20portrait%20style%20with%20warm%20coral%20and%20cream%20soft%20tones%2C%20dreamy%20atmospheric%20lighting%2C%20abstract%20organic%20composition%2C%20clean%20simple%20background%2C%20editorial%20aesthetic%2C%20no%20text%2C%20no%20face%2C%20no%20people&width=600&height=800&seq=work-portrait-03&orientation=portrait',
    },
    {
      slug: 'anzai-rara-biography',
      title: '安斋拉拉个人档案全解析',
      imageUrl: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20artistic%20minimalist%20portrait%20style%20with%20warm%20coral%20and%20cream%20soft%20tones%2C%20dreamy%20atmospheric%20lighting%2C%20abstract%20organic%20composition%2C%20clean%20simple%20background%2C%20editorial%20aesthetic%2C%20no%20text%2C%20no%20face%2C%20no%20people&width=600&height=800&seq=work-portrait-04&orientation=portrait',
    },
  ];

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-10">
          <div>
            <p className="text-xs md:text-sm text-accent-600 font-medium tracking-wide uppercase mb-2">
              作品精选
            </p>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热门作品
            </h2>
          </div>
          <Link
            to="/category/works"
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium transition-colors whitespace-nowrap cursor-pointer"
          >
            浏览全部 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {works.map((work, index) => (
            <Link
              key={work.slug + index}
              to={`/article/${work.slug}`}
              className="group block bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-accent-200 transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full aspect-[3/4] overflow-hidden">
                <img
                  src={work.imageUrl}
                  alt={work.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {work.title}
                </h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}